<template>
  <div>
    <!--Loading-->
    <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>

    <PageTitle title="Subject" />
    <div class="columns">
      <div class="column is-12">
        <div class="card">
          <div class="card-content">
            <b-field>
              <b-button @click="addNewSubject()" type="is-info" size="is-small">Create a new subject</b-button>
            </b-field>

            <!--Set Subject-->
            <b-modal :active.sync="modalNewSubject"
            has-modal-card
            trap-focus
            :destroy-on-hide="true"
            aria-role="dialog"
            aria-modal>
              <set-subject :subject_id="edit_subject_id" @over="modalNewSubject = false"></set-subject>
            </b-modal>

            <UpTable :paginated="true" :per-page="20" :data="fetchSubjects" searchable>
              <UpTableColumn v-slot="props" field="name" label="Name" sortable>{{props.row.name}}</UpTableColumn>
              <UpTableColumn v-slot="props" field="description" label="Description">{{props.row.description}}</UpTableColumn>
              <UpTableColumn v-slot="props" field="remarks" label="Remarks">{{props.row.remarks}}</UpTableColumn>
              <UpTableColumn v-slot="props" field="status" label="Status" sortable>
                <b-tag :type="props.row.status ? 'is-success' : 'is-danger'">
                  {{ props.row.status ? 'Active' : 'Inactive' }}
                </b-tag>
              </UpTableColumn>
              <UpTableColumn v-slot="props" field="created_at" label="Created At" sortable>{{$common.formatDate(props.row.created_at)}}</UpTableColumn>
              <UpTableColumn v-slot="props" label="Action">
                <div class="buttons">
                  <b-button @click="editSubject(props.row._id)" type="is-primary" size="is-small" icon-left="pencil"></b-button>
                  <b-button @click="deleteThisSubject(props.row._id)" type="is-danger" size="is-small" icon-left="delete"></b-button>
                </div>
              </UpTableColumn>
              <template #empty>
                <empty-table message="No subjects created."></empty-table>
              </template>
            </UpTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//Vuex
import {mapGetters, mapActions} from 'vuex'
import PageTitle from '@/components/PageTitle'
import EmptyTable from '@/components/EmptyTable'
import SetSubject from '@/components/Subject/SetSubject'

export default {
  name : 'Candidate',
  components : {
    PageTitle, EmptyTable, SetSubject
  },
  data(){
    return {
      isLoading : false,
      modalNewSubject : false,
      edit_subject_id : null
    }
  },
  computed : {
    ...mapGetters(['fetchSubjects', 'getTeacherToken'])
  },
  methods : {
    ...mapActions(['loadSubjects', 'deleteSubject']),
    addNewSubject(){
      this.modalNewSubject = true
    },
    editSubject(id){
      this.modalNewSubject = true
      this.edit_subject_id = id
    },
    deleteThisSubject(id){
      this.$buefy.dialog.confirm({
        title: 'Continue deleting this subject',
        message : 'Are you sure want to delete this subject permanently?',
        type : 'is-danger',
        onConfirm: () => {
          this.deleteSubject({
            token : this.getTeacherToken,
            subject : id
          }).then(() => {
            this.$buefy.toast.open({
              message: 'Subject deleted successfully',
              type: 'is-success'
            })
          }).catch(err => {
            this.$buefy.toast.open({
              message: err.response.data,
              type: 'is-danger'
            })
          })
        }
      })
    }
  },
  async created(){
    this.isLoading = true
    try{
      await this.loadSubjects({ token : this.getTeacherToken })
    }catch(err){
      this.$buefy.toast.open({
        message: err.response.data,
        type: 'is-danger'
      })
    }
    this.isLoading = false
  }
  
}
</script>